import { NgModule } from '@angular/core';
import { TOKENS } from '@trustedshops/tswp-core-masterdata';
import { OrganizationalContainerSelectionServiceImpl } from './services/organizational-container-selection.service';
import { OrganizationalContainerProviderImpl } from './services/organizational-container.provider';
import { FeatureBookingServiceImpl } from './services/feature-booking.service';
import { ProductFeatureServiceImpl } from './services/product-feature.service';
import { OnboardingServiceImpl } from './services/onboarding.service';
import { UserflowServiceImpl } from './services/userflow.service';
import { KameleoonServiceImpl } from './services/kameleoon.service';

@NgModule({
  providers: [
    { provide: TOKENS.OrganizationalContainerProvider, useClass: OrganizationalContainerProviderImpl },
    { provide: TOKENS.OrganizationalContainerSelectionService, useClass: OrganizationalContainerSelectionServiceImpl },
    { provide: TOKENS.FeatureBookingService, useClass: FeatureBookingServiceImpl },
    { provide: TOKENS.ProductFeatureService, useClass: ProductFeatureServiceImpl },
    { provide: TOKENS.OnboardingService, useClass: OnboardingServiceImpl },
    { provide: TOKENS.UserFlowService, useClass: UserflowServiceImpl },
    { provide: TOKENS.KameleoonService, useClass: KameleoonServiceImpl },
  ],
})
export class TswpCoreMasterdataModule { }
